import { render, staticRenderFns } from "./OrderRefund.vue?vue&type=template&id=19d3d1b0&scoped=true&"
import script from "./OrderRefund.vue?vue&type=script&lang=js&"
export * from "./OrderRefund.vue?vue&type=script&lang=js&"
import style0 from "./OrderRefund.vue?vue&type=style&index=0&id=19d3d1b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d3d1b0",
  null
  
)

export default component.exports